import { editarFiltroRequest, eliminarFiltroRequest, getFiltrosRequest, guardarFiltroRequest, updateConsentRequest, postUsuarioPerfilRequest, enabledUsuariosPerfilRequest, disabledUsuarioPerfilRequest } from './requests';
import { setEditarFiltroRequestStatus, setEliminarFiltroRequestStatus, setFiltros, setGuardarFiltroRequestStatus, setPostUpdateConsent, setUserPortraitDataRquest, setAllUsuarios,  setGetAllUsuariosRequestStatus, setInsertarUsuarioPerfilRequestStatus, setHabilitarUsuarioPerfilRequestStatus, setEliminarUsuarioPerfilRequestStatus} from './actions';
import {
  DatosPerfilesUsuario,
  EditarFiltro,
  EditarFiltroRequest,
  EliminarFiltro,
  EliminarFiltroRequest,
  GuardarFiltro,
  GuardarFiltroRequest,
  IDeleteUserPortraitRequest,
  IDeleteUserPortraitResponse,
  IPostConsentRequest,
  IPostConsentResponse,
} from './types';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import ActionTypes from 'store/usuarios/actionTypes';
import { RequestStatusTypes, RouteTypes, TxtTypes } from 'consts';
import {
  GetInfoUsersRequest,
  GetPerfilesUsuariosRequest,
  InfoUser,
  IGetUserPortraitResponse,
  PerfilesUsuario,
  IGetUserPortraitRequest,
  IUpdateUserPortraitRequest,
  IUpdateUserPortraitResponse,
  PerfilUsuario,
} from 'store/usuarios/types';
import {
  deleteUserPortrait,
  getInfoUsersRequest,
  getPerfilesUsuarioRequest,
  getAllUsuariosRequest,
  getUserPortrait,
  updateUserPortrait,
} from 'store/usuarios/requests';
import { ResponseFetcher } from 'utils/fetcher/types';
import {
  setAlumnPortraitRquest,
  setDeleteUserPortraitRquestStatus,
  setGetInfoUsersRequestStatus,
  setGetPerfilesUsuarioRequestStatus,
  setInfoUsers,
  setPerfilesUsuario,
  setUpdateUserPortraitRquestStatus,
  setUserPortraitRquest,
} from 'store/usuarios/actions';
import { makeSelectUsername } from 'store/app/selectors';
import { makeSelectTokenBearerToken } from 'store/oauth/selectors';
import { getEstadosPracticaRequest } from 'store/practicas/actions';
import {
  getAlumnoAuditoriaRequestSaga,
  getCursosActivosJornadaRequestSaga,
  getCursosAuditoriaRequestSaga,
  getEstacionesRequestSaga,
  getFechaMaximaPracticaRequestSaga,
  getFechaMinimaPracticaRequestSaga,
  getFilterAlumnoPracticaRequestSaga,
  getFilterCursoPracticaRequestSaga,
  getInstructoresPracticasRequestSaga,
  getJornadasUsuarioRequestSaga,
  getProvinciasRequestSaga,
  getSociedadesRequestSaga,
  getTipoServicioRequestSaga,
  getTiposPracticaRequestSaga,
  resetPaginationSaga,
} from 'store/practicas/sagas';
import { setModalDraftType, setMsgSubmit, setUserList } from 'store/app/actions';
import { makeSelectList } from '../practicas/selectors';
import { Practica } from '../practicas/types';
import {
  makeSelectFechaCreacion,
  makeSelectFechaModificacion,
  makeSelectFiltroId,
  makeSelectFiltroJson,
  makeSelectNombreFiltro,
  makeSelectNombrePagina,
  makeSelectPerfilesUsuarioDatosPerfilesUsuario,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
} from './selectors';

export default function* sagas() {
  yield takeEvery(
    ActionTypes.GET_PERFILES_USUARIO_REQUEST,
    getPerfilesUsuarioRequestSaga
  );
  yield takeEvery(ActionTypes.GET_INFO_USERS_REQUEST, getInfoUsersRequestSaga);

  yield takeLatest(ActionTypes.SET_PERFILES_USUARIO, initAppSaga);
  yield takeLatest(
    ActionTypes.GET_USER_PORTRAIT_REQUEST,
    getUserPortraitRequestSaga
  );
  yield takeLatest(
    ActionTypes.POST_UPDATE_CONSENT,
    postUpdateConsentRequestSaga
  );
  yield takeLatest(
    ActionTypes.UPDATE_USER_PORTRAIT_REQUEST,
    getUpdateUserPortraitRequestSaga
  );
  yield takeLatest(
    ActionTypes.DELETE_USER_PORTRAIT_REQUEST,
    getDeleteUserPortraitRequestSaga
  );
  yield takeLatest(
    ActionTypes.GET_ALUMN_PORTRAIT_REQUEST,
    getAlumnPortraitRequestSaga
  );
  yield takeEvery(ActionTypes.GET_FILTROS, getFiltrosRequestSaga);
  yield takeEvery(ActionTypes.ELIMINAR_FILTRO_REQUEST, eliminarFiltroRequestSaga);
  yield takeEvery(ActionTypes.GUARDAR_FILTRO_REQUEST, guardarFiltroRequestSaga);
  yield takeEvery(ActionTypes.EDITAR_FILTRO_REQUEST, editarFiltroRequestSaga);
  yield takeEvery(ActionTypes.GET_FILTROS_REQUEST, getFiltrosRequestSaga);

  //panel administracion
  yield takeEvery(ActionTypes.GET_ALL_USUARIOS, getAllUsuariosRequestSaga);
  yield takeEvery(ActionTypes.INSERTAR_USUARIO_PERFIL, insertarUsuarioPerfilRequestSaga);
  yield takeEvery(ActionTypes.HABILITAR_USUARIO_PERFIL, enableUsuarioPerfilRequestSaga);
  yield takeEvery(ActionTypes.ELIMINAR_USUARIO_PERFIL, eliminarUsuarioPerfilRequestSaga);


}

export function* getEstadosPracticaRequestSaga() {
  yield put(getEstadosPracticaRequest());
}


export function* getAllUsuariosRequestSaga() {
   try {

       const bearerToken = yield select(makeSelectTokenBearerToken());


       const response: ResponseFetcher<PerfilUsuario[]> = yield call(
         getAllUsuariosRequest,
         bearerToken,
       );

         if (response.ok) {
           yield put(setAllUsuarios(response.data));
           yield put(
               setGetAllUsuariosRequestStatus({
                 status: RequestStatusTypes.Success,
                 code: response.code,
                 url: response.url,
               })
           );
         }else {
           yield put(
             setGetAllUsuariosRequestStatus({
             status: RequestStatusTypes.Error,
             code: response.code,
             message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
             url: response.url,
           })
       );
         throw new Error(`Error: ${ActionTypes.GET_ALL_USUARIOS}`);

       }


     } catch (err) {
       console.error(err);
     }
}

export function* insertarUsuarioPerfilRequestSaga(params) {
  try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.usuarioAlta = usuario;

      const response: ResponseFetcher<any> = yield call(
        postUsuarioPerfilRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setInsertarUsuarioPerfilRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
          yield call(getAllUsuariosRequestSaga);
        }else {
          yield put(
            setInsertarUsuarioPerfilRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.INSERTAR_USUARIO_PERFIL}`);

      }


    } catch (err) {
      console.error(err);
    }
}


export function* enableUsuarioPerfilRequestSaga(params) {
  try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.idUsuarioModificacion = usuario;

      const response: ResponseFetcher<any> = yield call(
        enabledUsuariosPerfilRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setHabilitarUsuarioPerfilRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
          yield call(getAllUsuariosRequestSaga);
        }else {
          yield put(
            setHabilitarUsuarioPerfilRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.HABILITAR_USUARIO_PERFIL}`);

      }


    } catch (err) {
      console.error(err);
    }
}


export function* eliminarUsuarioPerfilRequestSaga(params) {
    try {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const usuario = yield select(makeSelectUsername());
      params.payload.idUsuarioModificacion = usuario;

      const response: ResponseFetcher<any> = yield call(
        disabledUsuarioPerfilRequest,
        params.payload,
        bearerToken
      );

        if (response.ok) {
          yield put(
              setEliminarUsuarioPerfilRequestStatus({
                status: RequestStatusTypes.Success,
                code: response.code,
                url: response.url,
              })
          );
          yield call(getAllUsuariosRequestSaga);
        }else {
          yield put(
            setEliminarUsuarioPerfilRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
      );
        throw new Error(`Error: ${ActionTypes.ELIMINAR_USUARIO_PERFIL}`);

      }


    } catch (err) {
      console.error(err);
    }
}


export function* getPerfilesUsuarioRequestSaga() {
  try {
    const userName = yield select(makeSelectUsername());
    const payload: GetPerfilesUsuariosRequest = {
      usuario: userName, // Get from App.reducer
    };
    const saved = JSON.parse(
      sessionStorage.getItem(`perfilesUsuario-${userName}`) ||
      '{"isSaved": false}'
    );
    const bearerToken = yield select(makeSelectTokenBearerToken());
    if (saved.isSaved === undefined) {
      yield put(setPerfilesUsuario(saved));
    } else {
      const response: ResponseFetcher<PerfilesUsuario> = yield call(
        getPerfilesUsuarioRequest,
        payload,
        bearerToken
      );

      if (response.ok) {
        sessionStorage.setItem(
          `perfilesUsuario-${userName}`,
          JSON.stringify(response.data)
        );
        yield put(setPerfilesUsuario(response.data));
        yield put(
          setGetPerfilesUsuarioRequestStatus({
            status: RequestStatusTypes.Success,
            code: response.code,
            url: response.url,
          })
        );
      } else {
        yield put(
          setGetPerfilesUsuarioRequestStatus({
            status: RequestStatusTypes.Error,
            code: response.code,
            message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
            url: response.url,
          })
        );
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInfoUsersRequestSaga() {
  try {
    const payload: GetInfoUsersRequest = {
      usuario: '',
      perfilId: '',
      listadoUsuarios: '',
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<InfoUser[]> = yield call(
      getInfoUsersRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setInfoUsers(response.data));
      yield put(
        setGetInfoUsersRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetInfoUsersRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.GET_INFO_USERS_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* initAppSaga() {
  // common sagas
  yield call(getFechaMinimaPracticaRequestSaga);
  yield call(getFechaMaximaPracticaRequestSaga);
  yield call(getSociedadesRequestSaga);
  yield call(getEstacionesRequestSaga);
  yield call(getFiltrosRequestSaga);

  switch (window.location.pathname) {
    // Audit
    case `${RouteTypes.AUDIT}`:
      yield call(initAppAuditSaga);
      break;
    // Create
    // Detail
    case `${RouteTypes.CREATE}`:
      yield call(initAppEditPracticeSaga);
      break;
    // Practices list
    case `${RouteTypes.HOME}`:
      yield call(initAppPracticesSaga);
      break;

    default:
      if (window.location.pathname.includes(RouteTypes.DETAIL_NO_PARAM)) {
        yield call(initAppEditPracticeSaga);
      }
      break;
  }
}
function* initAppAuditSaga() {
  yield call(getCursosAuditoriaRequestSaga);
  yield call(getEstacionesRequestSaga);
  yield call(getAlumnoAuditoriaRequestSaga);
  yield call(getProvinciasRequestSaga);
  yield call(resetPaginationSaga);
}

function* initAppPracticesSaga() {
  yield call(getFechaMinimaPracticaRequestSaga);
  yield call(getFechaMaximaPracticaRequestSaga);
  yield call(getEstadosPracticaRequestSaga);
  yield call(getFilterCursoPracticaRequestSaga, {});
  yield call(getInstructoresPracticasRequestSaga);
  yield call(getFilterAlumnoPracticaRequestSaga, {});
  yield call(getTiposPracticaRequestSaga);
  yield call(getTipoServicioRequestSaga);
  yield call(resetPaginationSaga);
}

function* initAppEditPracticeSaga() {
  yield call(getFechaMinimaPracticaRequestSaga);
  yield call(getFechaMaximaPracticaRequestSaga);

  yield call(getJornadasUsuarioRequestSaga);
  yield call(getEstacionesRequestSaga);
  yield call(getTipoServicioRequestSaga);
  yield call(getInstructoresPracticasRequestSaga);
  yield call(getTiposPracticaRequestSaga);
  yield call(getCursosActivosJornadaRequestSaga);
}

export function* getInfoUsers() {
  const list: Practica[] = yield select(makeSelectList());
  const usersProfiles: PerfilesUsuario = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuario
  );

  const usersList: string[] = [];
  if (usersProfiles && list) {
    list.forEach((item: any) => {
      usersList.push(item.ID_ALUMNO);
    });
    yield put(setUserList(usersList.join(',')));
  }
}

export function* getUserPortraitRequestSaga() {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  //Miramos en el sessionStorage
  const saved = JSON.parse(
    sessionStorage.getItem('userPortrait') || '{"isSaved": false}'
  );

  //Si esta guardado cogemos de los datos guardados
  if (
    saved.isSaved &&
    saved.usuario === usuario &&
    saved.PENDIENTE_DE_VALIDAR !== 'TRUE'
  ) {
    if (saved.FOTO_PENDIENTE_VALIDAR !== '') {
      yield put(setUserPortraitRquest(saved.FOTO_PENDIENTE_VALIDAR));
    } else {
      yield put(setUserPortraitRquest(saved.FOTO_PERFIL));
    }
  } else {
    //Si no esta guardado o no es mismo usuario hacemos la peticion
    const payload: IGetUserPortraitRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnoId: usuario,
    };

    const response: ResponseFetcher<IGetUserPortraitResponse> = yield call(
      getUserPortrait,
      payload
    );

    if (response.ok) {
      //Guardamos los datos obtenidos
      const dataToSave = {
        ...response.data,
        usuario: usuario,
        isSaved: true,
      };
      sessionStorage.setItem('userPortrait', JSON.stringify(dataToSave));

      if (response.data.FOTO_PENDIENTE_VALIDAR !== '') {
        yield put(setUserPortraitRquest(response.data.FOTO_PENDIENTE_VALIDAR));
      } else {
        yield put(setUserPortraitRquest(response.data.FOTO_PERFIL));
      }
      yield put(setUserPortraitDataRquest(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_USER_PORTRAIT_REQUEST}`);
    }
  }
}

export function* postUpdateConsentRequestSaga() {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: IPostConsentRequest = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    user: usuario,
    profile: perfilSelected?.ID_PERFIL,
  };

  const response: ResponseFetcher<IPostConsentResponse> = yield call(
    updateConsentRequest,
    payload
  );

  if (response.ok) {
    sessionStorage.removeItem('userPortrait');
    yield put(setPostUpdateConsent(response));
  } else {
    throw new Error(`Error: ${ActionTypes.POST_UPDATE_CONSENT}`);
  }
}

export function* getAlumnPortraitRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  //Miramos en el sessionStorage
  const saved = JSON.parse(
    sessionStorage.getItem('alumnSaved-' + params.payload) ??
    '{"isSaved": false}'
  );

  //Si esta guardado cogemos de los datos guardados
  if (saved.isSaved && saved.alumnoId === params.payload) {
    yield put(setAlumnPortraitRquest(saved.FOTO_PERFIL));
  } else {
    //Si no esta guardado o no es mismo usuario hacemos la peticion

    const payload: IGetUserPortraitRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      alumnoId: params.payload,
    };

    const response: ResponseFetcher<IGetUserPortraitResponse> = yield call(
      getUserPortrait,
      payload
    );
    if (response.ok) {
      const dataToSave = {
        ...response.data,
        alumnoId: params.payload,
        isSaved: true,
      };
      sessionStorage.setItem(
        'alumnSaved-' + params.payload,
        JSON.stringify(dataToSave)
      );
      // yield put(setAlumnPortraitRquest(response.data.URL_IMAGE))

      yield put(setAlumnPortraitRquest(response.data.FOTO_PERFIL));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_ALUMN_PORTRAIT_REQUEST}`);
    }
  }
}

export function* getUpdateUserPortraitRequestSaga(file: any) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: IUpdateUserPortraitRequest = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    bytes: file.payload,
  };

  const response: ResponseFetcher<IUpdateUserPortraitResponse> = yield call(
    updateUserPortrait,
    payload
  );

  if (response.ok) {
    sessionStorage.removeItem('userPortrait');
    yield put(
      setUpdateUserPortraitRquestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      })
    );
  } else {
    setUpdateUserPortraitRquestStatus({
      status: RequestStatusTypes.Error,
      code: response.code,
      message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
      url: response.url,
    });
    throw new Error(
      `Error: ${ActionTypes.UPDATE_USER_PORTRAIT_REQUEST_STATUS}`
    );
  }
}

export function* getDeleteUserPortraitRequestSaga() {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: IDeleteUserPortraitRequest = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
  };

  const response: ResponseFetcher<IDeleteUserPortraitResponse> = yield call(
    deleteUserPortrait,
    payload
  );

  if (response.ok) {
    sessionStorage.removeItem('userPortrait');
    yield put(
      setDeleteUserPortraitRquestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      })
    );
    yield put(setUserPortraitRquest(''));
    yield put(
      setUserPortraitDataRquest({
        CONSENTIMIENTO: 'N',
        MESSAGE: '',
        PENDIENTE_DE_VALIDAR: 'FALSE',
        STATUS: '',
        FOTO_PERFIL: '',
      })
    );
  } else {
    setDeleteUserPortraitRquestStatus({
      status: RequestStatusTypes.Error,
      code: response.code,
      message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
      url: response.url,
    });
    throw new Error(
      `Error: ${ActionTypes.DELETE_USER_PORTRAIT_REQUEST_STATUS}`
    );
  }
}

//Filtros

export function* getFiltrosRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected());
    let nombrePagina = '';

    const currentUrl = window.location.pathname;
    switch (currentUrl) {
      case RouteTypes.HOME:
        nombrePagina = 'Listado de prácticas';
        break;
      case RouteTypes.AUDIT:
        nombrePagina = 'Auditar cuaderno';
        break;
      case RouteTypes.COURSE:
        nombrePagina = 'Listado de cursos';
        break;
      case RouteTypes.REPORT_COURSES_CLOSING:
        nombrePagina = 'Informes de cursos pendientes de cierre';
        break;
      case RouteTypes.REPORT_HOURS:
        nombrePagina = 'Informes de horas';
        break;
      case RouteTypes.REPORT_INFRAESTRUCTURE:
        nombrePagina = 'Informes de Habilitaciones Infraestructura';
        break;
      case RouteTypes.REPORT_HOURS_INSTRUCTOR:
        nombrePagina = 'Informes de horas formación de instructor';
        break;
      case RouteTypes.ALTA_ADMINISTRADORES:
        nombrePagina = 'Alta Administradores';
        break;
      case RouteTypes.ALTA_SUPERVISORES:
        nombrePagina = 'Alta Supervisores';
        break;
      case RouteTypes.ALTA_VISUALIZADORES:
        nombrePagina = 'Alta Visualizadores';
        break;
      case RouteTypes.CERTIFICADOS_PRACTICAS:
        nombrePagina = 'Certificados de prácticas';
        break;
      default:
        nombrePagina = 'Listado de prácticas';
    }

    const payload = {
      usuario,
      perfil: perfilSelected?.ID_PERFIL,
      nombrePagina
    };

    const saved = JSON.parse(
      sessionStorage.getItem(
        `savedFiltros-${payload.usuario}-${payload.perfil}`
      ) || '{"isSaved": false}'
    );
    if (saved.isSaved === undefined) {
      yield put(setFiltros(saved));
    } else {
      const bearerToken = yield select(makeSelectTokenBearerToken());
      const response = yield call(getFiltrosRequest, payload, bearerToken);

      if (response.ok) {
        yield put(setFiltros(response.data));
      } else {
        throw new Error(`Error: ${ActionTypes.GET_FILTROS_REQUEST}`);
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function* guardarFiltroRequestSaga() {
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected());
    const nombreFiltro: string = yield select(makeSelectNombreFiltro());
    const nombrePagina: string = yield select(makeSelectNombrePagina());
    const filtroJson: any = yield select(makeSelectFiltroJson());

    const filtroPayload = {
      FILTRODATOS: {
        ID_USUARIO: usuario,
        ID_PERFIL: perfilSelected?.ID_PERFIL,
        NOMBRE_FILTRO: nombreFiltro,
        NOMBRE_PAGINA: nombrePagina,
      },
      FILTRO_JSON: filtroJson,
    };

    const payload: GuardarFiltroRequest = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      filtro: JSON.stringify(filtroPayload)
    };

    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<GuardarFiltro> = yield call(
      guardarFiltroRequest,
      payload,
      bearerToken
    );

    if (response.ok /* && response.data?.STATUS !== 'KO' */) {
      yield put(setMsgSubmit(`Filtro guardado correctamente.`));
      yield put(setModalDraftType('success'));
      yield put(setGuardarFiltroRequestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      }));
    } else {
      yield put(setMsgSubmit(`Error al guardar el filtro.`));
      yield put(setModalDraftType('alert'));
      yield put(setGuardarFiltroRequestStatus({
        status: RequestStatusTypes.Error,
        code: response.code,
        message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
        url: response.url,
      }));
      throw new Error(`Error: ${ActionTypes.GUARDAR_FILTRO_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* eliminarFiltroRequestSaga() {
  try {
    const idFiltro: string = yield select(makeSelectFiltroId());

    const payload: EliminarFiltroRequest = {
      idFiltro
    };

    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<EliminarFiltro> = yield call(
      eliminarFiltroRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setMsgSubmit(`Filtro eliminado correctamente.`));
      yield put(setModalDraftType('success'));
      yield put(setEliminarFiltroRequestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      }));
    } else {
      yield put(setMsgSubmit(`Error al elimnar el filtro.`));
      yield put(setModalDraftType('alert'));
      yield put(setEliminarFiltroRequestStatus({
        status: RequestStatusTypes.Error,
        code: response.code,
        message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
        url: response.url,
      }));
      throw new Error(`Error: ${ActionTypes.ELIMINAR_FILTRO_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* editarFiltroRequestSaga() {
  try {
    const usuario: string = yield select(makeSelectUsername());
    const perfilSelected: DatosPerfilesUsuario = yield select(makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected());
    const nombreFiltro: string = yield select(makeSelectNombreFiltro());
    const nombrePagina: string = yield select(makeSelectNombrePagina());
    const filtroJson: any = yield select(makeSelectFiltroJson());
    const idFiltro: string = yield select(makeSelectFiltroId());
    const fechaCreacion: number = yield select(makeSelectFechaCreacion());
    const fechaModificacion: number = yield select(makeSelectFechaModificacion());


    const payload: EditarFiltroRequest = {
      idUsuario: usuario,
      idPerfil: perfilSelected?.ID_PERFIL,
      idFiltro: idFiltro,
      nombrePagina: nombrePagina,
      nombreFiltro: nombreFiltro,
      fechaCreacion: fechaCreacion,
      fechaModificacion: fechaModificacion,
      filtro: JSON.stringify(filtroJson),
    };

    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<EditarFiltro> = yield call(
      editarFiltroRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(setMsgSubmit(`Filtro editado correctamente.`));
      yield put(setModalDraftType('success'));
      yield put(setEditarFiltroRequestStatus({
        status: RequestStatusTypes.Success,
        code: response.code,
        url: response.url,
      }));
    } else {
      yield put(setMsgSubmit(`Error al editar el filtro.`));
      yield put(setModalDraftType('alert'));
      yield put(setEditarFiltroRequestStatus({
        status: RequestStatusTypes.Error,
        code: response.code,
        message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
        url: response.url,
      }));
      throw new Error(`Error: ${ActionTypes.EDITAR_FILTRO_REQUEST}`);
    }
  } catch (err) {
    console.error(err);
  }
}
